"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AgreementViewContainer = void 0;
var _SourceProvider = require("../SourceProvider");
var _AgreementView = require("./AgreementView");
const AgreementViewContainer = exports.AgreementViewContainer = (0, _SourceProvider.SourceProvider)(_AgreementView.AgreementView);